export const getNotViewed = (state) => {
	return state.notViewed;
}
